import SvgAnxiousEmojiSecondary from './svgs/AnxiousEmojiSecondary.js';
import SvgAnxiousEmoji from './svgs/AnxiousEmoji.js';
import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import { useIcon } from '../../shared-components/icon/index.js';

var anxiousEmoji = (props => useIcon(SvgAnxiousEmoji, SvgAnxiousEmojiSecondary, props));

export { anxiousEmoji as default };
